export default "__VITE_ASSET__zE47j3xp__"